module.exports = "/images/icon_sharelink.png?083aa5aa852dd8a5c4f2c30c0458367a";